<div class="ai-hub-form pl-3 mt-3">
	<div class="d-flex justify-content-between">
		<div [routerLink]="''" class="cursor-pointer">
			<img src="./assets/img/asset-logo.svg" class="asset-logo" />
			<h4 class="d-inline-block">bizbrAIn</h4>
		</div>

		<div>
			<a class="cursor-pointer input-element" (click)="prefillSampleData()" href="javascript:void(0)">
				<img src="./assets/img/prefill.svg" alt="Prefill data" />
				Prefill sample data
			</a>
		</div>
	</div>

	<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showForm">
		<div class="data-container">
			<div class="mt-3">
				<mat-button-toggle-group name="uploadType" aria-label="Upload option" formControlName="toggleBtn" (change)="openDialog($event)">
					<mat-button-toggle value="file">Upload file</mat-button-toggle>
					<mat-button-toggle value="text">Paste data as text</mat-button-toggle>
				</mat-button-toggle-group>
			</div>

			<!-- Upload -->
			<div *ngIf="showUpload" class="input-element">
				<label>Upload your file</label>
				<p class="dataLimit"> Please note: We currently support visualization of one chart at a time and the data is limited to 20 rows and columns respectively. </p>
				<ngx-file-drop
					(onFileDrop)="drop($event)"
					[dropZoneClassName]="'asset-logo--dropzone'"
					[showBrowseBtn]="false"
					[accept]="'.txt, .pdf, .xls, .xlsx, .csv'"
					[multiple]="false">
					<ng-template
						ngx-file-drop-content-tmp
						let-openFileSelector="openFileSelector">
						<button type="button" (click)="openFileSelector()">
							<img src="./assets/img/upload.svg" alt />
						</button>
						<p class="text mb-1">Browse & Upload</p>
						<small class="text-black">Only .xlsx, .txt, .pdf files are allowed.</small>
					</ng-template>
				</ngx-file-drop>
				<div class="file-name-div py-2 text-center" *ngIf="fileName">
					<!-- <label>Uploaded File</label> -->
					<p class="text d-inline-block mr-3 mb-0">
						<img src="./assets/img/excel.svg" class="image-fluid" *ngIf="fileType.includes('spreadsheetml')">
						<img src="./assets/img/pdf.svg" class="image-fluid" *ngIf="fileType.includes('pdf')">
						<img src="./assets/img/txt.svg" class="image-fluid" *ngIf="fileType.includes('text')">
						{{fileName}}
					</p>
					<mat-icon class="cursor-pointer" (click)="clearFile()">close</mat-icon>
				</div>
			</div>

			<!--Paste Textarea -->
			<ng-container *ngIf="!showUpload">
				<label class="mt-3">Paste data from excel</label>
				<p class="dataLimit"> Please note: We currently support visualization of one chart at a time and the data is limited to 10 rows and columns respectively. </p>
				<textarea formControlName="dataInput"
					placeholder="Paste any data here to visualize and get inisghts."
					rows="7" class="w-100"></textarea>
			</ng-container>

			<div class="input-element">
				<label>Chart type</label>
				<mat-form-field appearance="fill">
					<mat-label>Select...</mat-label>
					<mat-select formControlName="chartType">
						<mat-option *ngFor="let option of chartTypes" [value]="option.value">
							{{option.viewValue}}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<!--Additional Textarea -->
			<label class="input-element">Enter additional criteria</label>
			<textarea formControlName="additionalInformation" rows="3" class="w-100"
				placeholder="Type here any additional information that we should consider."></textarea>

			<!-- <app-audio></app-audio> -->
			<div class="align-items-center d-flex">
				<a class="cursor-pointer input-element" (click)="resetAll()" href="javascript:void(0)">
					Reset All
				</a>
				<button class="btn btn-primary input-element ml-3" type="submit()">
					Generate
				</button>
			</div>
		</div>
	</form>
	<mat-icon (click)="generateAudio(greetingBye)" class="audio-icon cursor-pointer greet-bye">audiotrack</mat-icon>
</div>

<audio controls="controls" autobuffer="autobuffer" autoplay="autoplay" id="greeting" *ngIf="audioBlobUrl" style="display:none;">
	<source [src]="audioBlobUrl" />
</audio>
